import { gql } from 'graphql.macro'
import SensorEditFragment from '../../../lib/SensorEditFragment'

export default gql`
  mutation DeleteSensor($id: ID!) {
    deleteSensor(id: $id) {
      ...SensorEditFragment
    }
  }

  ${SensorEditFragment}
`
